import { authenticatedHttpClient } from './httpClient';
import { Order } from '../models/order';
import {
  ClientOrder,
  ClientOrderQueryResult,
  ClientOrderUpdate,
} from '../models/clientOrder';
import {
  createApiListCursor,
  getApiListOffset,
} from '../utils/apiListCursor';

export type ClientOrdersListCursor = { __apiOffset: number } | null;

export const loadClientOrders = async (
  organizationId: string,
  searchInput?: string,
  lastDoc?: ClientOrdersListCursor | { __apiOffset?: number } | null,
  limitCount: number = 10,
  status?: string
): Promise<{
  clientOrders: ClientOrder[];
  lastDoc: ClientOrdersListCursor;
  hasMore: boolean;
}> => {
  const offset = getApiListOffset(lastDoc as { __apiOffset?: number } | null, 0);
  const params = new URLSearchParams();
  params.set('limit', String(limitCount));
  params.set('offset', String(offset));
  if (searchInput?.trim()) {
    params.set('search_term', searchInput.trim().toLowerCase());
  }
  if (status) params.set('status', status);
  const result = await authenticatedHttpClient.get<ClientOrderQueryResult>(
    `/client-orders/${organizationId}?${params.toString()}`
  );
  const rows = result.clientOrders || [];
  return {
    clientOrders: rows,
    hasMore: Boolean(result.hasMore),
    lastDoc: createApiListCursor(offset + rows.length),
  };
};

export const updateClientOrderServer = async (
  organizationId: string,
  id: string,
  payload: ClientOrderUpdate
): Promise<ClientOrder> => {
  return authenticatedHttpClient.put<ClientOrder>(
    `/client-orders/${organizationId}/${id}`,
    payload
  );
};

export const convertClientOrderServer = async (
  organizationId: string,
  id: string
): Promise<Order> => {
  return authenticatedHttpClient.post<Order>(
    `/client-orders/${organizationId}/${id}/convert`,
    {}
  );
};

export const rejectClientOrderServer = async (
  organizationId: string,
  id: string,
  reason?: string
): Promise<ClientOrder> => {
  return authenticatedHttpClient.post<ClientOrder>(
    `/client-orders/${organizationId}/${id}/reject`,
    { reason: reason || '' }
  );
};
